import { Page, Document, StyleSheet } from "@react-pdf/renderer";
import { Invoice, Setting } from "../../../generated/graphql";
import InvoiceHeader from "./Header";
import InvoiceItems from "./Items";
import InvoiceSocials from "./Socials";
import InvoiceNotes from "./Notes";
import InvoicePaymentInfo from "./PaymentInfo";
import InvoiceSignature from "./Signature";

const PrintInvoice: React.FC<{ invoice: Invoice; settings?: Setting[] }> = ({
  invoice,
  settings,
}) => {
  return (
    <Document>
      <Page size={[500, 792]} style={styles.page} orientation="portrait">
        <InvoiceHeader invoice={invoice} />
        <InvoiceItems invoice={invoice} />
        <InvoicePaymentInfo invoice={invoice} />
        <InvoiceNotes settings={settings} />
        <InvoiceSignature invoice={invoice} />
        <InvoiceSocials />
      </Page>
    </Document>
  );
};

// Create styles
const styles = StyleSheet.create({
  page: {
    paddingTop: 30,
    paddingBottom: 30,
    paddingLeft: 24,
    paddingRight: 24,
  },
});

export default PrintInvoice;
